/** @flow */
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import Up from 'material-ui/svg-icons/action/trending-up';
import Down from 'material-ui/svg-icons/action/trending-down';
import { Percent } from 'common/components/Number';
import type { ComparedMetric } from '../modules/dashboard/domain/DashboardData';

const Container = styled.span`
  display: flex;
  align-items: center;
`;

const Text = styled.span`
  margin-left: ${({ theme }) => theme.metrics.tinyMargin}px;
  font-weight: bold;
  color: ${props => props.theme.V3.colors[props.style.color].normal};
`;

type IconSize = {
  height: number;
  width: number;
};

type Props = {
  percent: number;
  iconSize?: IconSize;
  textStyle?: Object;
  theme: Object;
}

const defaultIconSize = {
  width: 40,
  height: 40,
};

const renderIcon = (percent: number, iconSize: IconSize, colors: Object) => {
  let Icon;
  let color;

  if (percent >= 0) {
    Icon = Up;
    color = colors.gain.normal;
  } else {
    Icon = Down;
    color = colors.loss.normal;
  }

  return <Icon color={color} style={iconSize} />;
};

export function calculateIncreaseDecreasePercent(metric: ComparedMetric) {
  if (metric.compared === 0) {
    return undefined;
  }

  return (metric.current - metric.compared) / metric.compared;
}

function IncreaseDecreasePercent({ percent, style, iconSize, textStyle, theme }: Props) {
  const size = { ...defaultIconSize, ...iconSize };

  return (
    <Container>
      {renderIcon(percent, size, theme.V3.colors)}
      <Text percent={percent} style={{ ...textStyle, color: percent >= 0 ? 'gain' : 'loss' }}>
        <Percent value={Math.abs(percent)} roundAt={2} />
      </Text>
    </Container>
  );
}

export default withTheme(IncreaseDecreasePercent);



// WEBPACK FOOTER //
// ./src/statsradio/components/IncreaseDecreasePercent.js